import { render, staticRenderFns } from "./commonBg.vue?vue&type=template&id=0b469908&scoped=true&"
import script from "./commonBg.vue?vue&type=script&lang=ts&"
export * from "./commonBg.vue?vue&type=script&lang=ts&"
import style0 from "./commonBg.vue?vue&type=style&index=0&id=0b469908&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b469908",
  null
  
)

export default component.exports